import { v4 as uuidv4 } from "uuid";

class BasicAttributes {
  constructor(type) {
    this.type = type;
    this.uid = uuidv4();
  }
}

class FirstName extends BasicAttributes {
  constructor() {
    super("firstName");
    this.label = "First Name";
    this.showLabel = true;
    this.placeholder = "Enter First Name";
    this.helpText = "";
    this.styleClasses = [];
    this.isRequired = true;
  }
  setValue(propName, value) {
    this[propName] = value;
  }
  setValues(object) {
    return Object.assign(this, object);
  }
  getValue(propName) {
    return this[propName];
  }
}
class LastName extends BasicAttributes {
  constructor() {
    super("lastName");
    this.label = "Last Name";
    this.showLabel = true;
    this.placeholder = "Enter Last Name";
    this.helpText = "";
    this.styleClasses = [];
    this.isRequired = true;
  }
  setValue(propName, value) {
    this[propName] = value;
  }
  setValues(object) {
    return Object.assign(this, object);
  }
  getValue(propName) {
    return this[propName];
  }
}
class Email extends BasicAttributes {
  constructor() {
    super("email");
    this.label = "Email";
    this.showLabel = true;
    this.placeholder = "Enter your email";
    this.helpText = "";
    this.styleClasses = [];
    this.isRequired = true;
  }
  setValue(propName, value) {
    this[propName] = value;
  }
  setValues(object) {
    return Object.assign(this, object);
  }
  getValue(propName) {
    return this[propName];
  }
}
class Phone extends BasicAttributes {
  constructor() {
    super("phone");
    this.label = "Phone";
    this.showLabel = true;
    this.countryCode = "IN";
    this.placeholder = "Enter your phone";
    this.helpText = "";
    this.styleClasses = [];
    this.isRequired = true;
  }
  setValue(propName, value) {
    this[propName] = value;
  }
  setValues(object) {
    return Object.assign(this, object);
  }
  getValue(propName) {
    return this[propName];
  }
}
class Address extends BasicAttributes {
  constructor() {
    super("address");
    this.showLabel = true;
    this.placeholder = "Enter your phone";
    this.styleClasses = [];
    this.fields = {
      addressLine1: {
        showField: true,
        label: "Address line 1",
        placeholder: "Enter address line 1",
        isRequired: true,
      },
      addressLine2: {
        showField: true,
        label: "Address line 2",
        placeholder: "Enter address line 2",
        isRequired: true,
      },
      city: {
        showField: true,
        label: "City",
        placeholder: "Enter city",
        isRequired: true,
      },
      state: {
        showField: true,
        label: "State",
        placeholder: "Enter state",
        isRequired: true,
      },
      zipCode: {
        showField: true,
        label: "ZIP/ Postal code",
        placeholder: "Enter postal code",
        isRequired: true,
      },
      country: {
        showField: true,
        label: "Country",
        placeholder: "Select country",
        isRequired: true,
      },
    };
  }
  setValue = (propName, value) => {
    this[propName] = value;
  };
  setNestedPropValue = (parentPropName, childPropName, value) => {
    this.fields[parentPropName][childPropName] = value;
  };
  setValues = (object) => {
    return Object.assign(this, object);
  };
  getValue = (propName) => {
    return this[propName];
  };
}
class TextField extends BasicAttributes {
  constructor() {
    super("textField");
    this.label = "Enter label";
    this.name = "";
    this.showLabel = true;
    this.placeholder = "Placeholder text";
    this.helpText = "";
    this.styleClasses = [];
    this.isRequired = true;
  }
  setValue(propName, value) {
    this[propName] = value;
  }
  setValues(object) {
    return Object.assign(this, object);
  }
  getValue(propName) {
    return this[propName];
  }
}
class Url extends BasicAttributes {
  constructor() {
    super("url");
    this.label = "URl";
    this.name = "";
    this.showLabel = true;
    this.placeholder = "Enter URl";
    this.helpText = "";
    this.styleClasses = [];
    this.isRequired = true;
  }
  setValue(propName, value) {
    this[propName] = value;
  }
  setValues(object) {
    return Object.assign(this, object);
  }
  getValue(propName) {
    return this[propName];
  }
}
class Rating extends BasicAttributes {
  constructor() {
    super("rating");
    this.label = "Rating";
    this.showLabel = true;
    this.name = "";
    this.ratingScale = "5";
    this.defaultRating = "0";
    this.ratingColor = "#000000";
    this.gradeIndex = "0";
    this.placeholder = "Placeholder text";
    this.helpText = "";
    this.styleClasses = [];
    this.isRequired = true;
  }
  setValue(propName, value) {
    this[propName] = value;
  }
  setValues(object) {
    return Object.assign(this, object);
  }
  getValue(propName) {
    return this[propName];
  }
}
class Paragraph extends BasicAttributes {
  constructor() {
    super("paragraph");
    this.label = "Enter label";
    this.name = "";
    this.showLabel = true;
    this.placeholder = "Placeholder";
    this.helpText = "";
    this.styleClasses = [];
    this.isRequired = true;
  }
  setValue(propName, value) {
    this[propName] = value;
  }
  setValues(object) {
    return Object.assign(this, object);
  }
  getValue(propName) {
    return this[propName];
  }
}
class Number extends BasicAttributes {
  constructor() {
    super("number");
    this.label = "Number";
    this.showLabel = true;
    this.name = "";
    this.placeholder = "Placeholder text";
    this.helpText = "";
    this.styleClasses = [];
    this.isRequired = true;
  }
  setValue(propName, value) {
    this[propName] = value;
  }
  setValues(object) {
    return Object.assign(this, object);
  }
  getValue(propName) {
    return this[propName];
  }
}
class DropDown extends BasicAttributes {
  constructor() {
    super("dropDown");
    this.label = "DropDown";
    this.name = "";
    this.showLabel = true;
    this.choices = [{ name: "choice-0", value: "" }];
    this.placeholder = "Select";
    this.helpText = "";
    this.styleClasses = [];
    this.isRequired = true;
    this.isChecked = false;
  }
  setValue(propName, value) {
    this[propName] = value;
  }
  setValues(object) {
    return Object.assign(this, object);
  }
  getValue(propName) {
    return this[propName];
  }
}
class CheckBox extends BasicAttributes {
  constructor() {
    super("checkBox");
    this.label = "CheckBox";
    this.name = "";
    this.showLabel = true;
    this.choices = [{ id: "choice-0", name: "", value: "" }];
    //this.placeholder = "Placeholder text";
    //this.helpText = "";
    this.styleClasses = [];
    this.isRequired = true;
  }
  setValue(propName, value) {
    this[propName] = value;
  }
  setValues(object) {
    return Object.assign(this, object);
  }
  getValue(propName) {
    return this[propName];
  }
}

export function getFieldInstance(type) {
  switch (type) {
    case "firstName":
      return new FirstName();
    case "lastName":
      return new LastName();
    case "email":
      return new Email();
    case "phone":
      return new Phone();
    case "address":
      return new Address();
    case "textField":
      return new TextField();
    case "url":
      return new Url();
    case "rating":
      return new Rating();
    case "paragraph":
      return new Paragraph();
    case "number":
      return new Number();
    case "dropDown":
      return new DropDown();
    case "checkBox":
      return new CheckBox();
  }
}

export function getStandardInstance(field, standardFields) {
  switch (field.type) {
    case "textField": {
      const existingFields = JSON.parse(
        JSON.stringify(standardFields[field.type])
      );
      existingFields.push(field);
      return existingFields;
    }
    case "url": {
      const existingFields = JSON.parse(
        JSON.stringify(standardFields[field.type])
      );
      existingFields.push(field);
      return existingFields;
    }
    case "paragraph": {
      const existingFields = JSON.parse(
        JSON.stringify(standardFields[field.type])
      );
      existingFields.push(field);
      return existingFields;
    }
    case "number": {
      const existingFields = JSON.parse(
        JSON.stringify(standardFields[field.type])
      );
      existingFields.push(field);
      return existingFields;
    }
    case "checkBox": {
      const existingFields = JSON.parse(
        JSON.stringify(standardFields[field.type])
      );
      existingFields.push(field);
      return existingFields;
    }
    case "dropDown": {
      const existingFields = JSON.parse(
        JSON.stringify(standardFields[field.type])
      );
      existingFields.push(field);
      return existingFields;
    }
    case "rating": {
      const existingFields = JSON.parse(
        JSON.stringify(standardFields[field.type])
      );
      existingFields.push(field);
      return existingFields;
    }
  }
}

export function extractContent(s) {
  var span = document.createElement("span");
  span.innerHTML = s;
  return span.textContent || span.innerText;
}
